import React from 'react';
import ReactDOM from 'react-dom';
import { T } from '../../../../common/locale/translate';

export default class TripLength extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: '',
      active: false,
      pristine: true,
      duration: {
        min: '',
        max: '',
        name: ''
      }
    };
  }

  componentDidMount = () => {
    document.addEventListener(
      'click',
      this.handleClickOutside.bind(this),
      true
    );
    this.handleStartingValuesSet(this.props);
  };

  componentWillReceiveProps = nextProps => {
    this.handleStartingValuesSet(nextProps);
  };

  componentWillUnmount = () => {
    document.removeEventListener(
      'click',
      this.handleClickOutside.bind(this),
      true
    );
  };

  render = () => (
    <div
      className={`trip-length select-wrapper animated-text-form extended ${
        this.state.active ? 'active' : ''
      } ${this.props.filter_active ? '' : 'filter-disabled'}`}
      ref={() => {
        this.returnSearchedValue = this.returnSearchedValue.bind(this);
      }}
    >
      <label className="animated-text-label" htmlFor="trip-lenght-input">
        <span className="animated-text-label-name">{this.props.title}</span>
      </label>
      <i className="dropdown-icon fa fa-chevron-down" />
      <input
        id="trip-lenght-input"
        type="text"
        value={this.formatName(this.state.duration)}
        className="animated-text-input"
        placeholder=""
        onChange={this.handleChange}
        onFocus={this.handleFocus}
        readOnly
      />
      <div className="dropdown-menu">
        <div className="reset-filter-custom mobile">
          <span onClick={this.handleReset} className="reset">
            <span> {T('clear')} </span>
          </span>
          <span onClick={this.handleClose} className="confirm">
            <span> {T('choose')} </span>
          </span>
        </div>
        <i className="fa fa-times close-icon" onClick={this.handleClose} />
        <div className="dropdown-header">
          <span> {T('days_count')} </span>
        </div>
        <div className="custom-range-wrapper">
          <input
            type="radio"
            name="length"
            ref={radio => {
              this.hiddenRadio = radio;
            }}
          />
          <div className="input-wrapper">
            <input
              type="text"
              placeholder={T('from')}
              name="min"
              value={this.state.duration.min}
              onFocus={this.handleRangeInputFocus}
              onBlur={this.handleRangeInputBlur}
              onChange={this.handleRangeInputChange}
            />
          </div>
          <div className="input-wrapper">
            <input
              type="text"
              placeholder={T('to')}
              name="max"
              value={this.state.duration.max}
              onFocus={this.handleRangeInputFocus}
              onBlur={this.handleRangeInputBlur}
              onChange={this.handleRangeInputChange}
            />
          </div>
        </div>
        <div className="reset-filter desktop">
          <span onClick={this.handleClose} className="confirm">
            <span> {T('choose')} </span>
          </span>
        </div>
      </div>
    </div>
  );

  handleStartingValuesSet = props => {
    const { duration_min, duration_max } = this.props;
    const durationMin = duration_min
      ? duration_min
      : props.duration.default.min;
    const durationMax = duration_max
      ? duration_max
      : props.duration.default.max;

    if (this.state.pristine && (durationMin || durationMax)) {
      const duration = {
        min: durationMin,
        max: durationMax
      };
      this.setState({
        duration,
        pristine: false
      });
    }
  };

  stopEventBehaviour(event) {
    event.stopPropagation();
    event.preventDefault();
  }

  handleClickOutside = event => {
    const domNode = ReactDOM.findDOMNode(this);
    if ((!domNode || !domNode.contains(event.target)) && this.state.active) {
      this.setState({ active: false });
      this.stopEventBehaviour(event);
    }
  };

  handleChange = event =>
    this.setState({ duration: JSON.parse(event.target.value) });

  handleClose = () => this.setState({ active: false });

  handleFocus = () => this.setState({ active: true });

  handleRangeInputFocus = event => {
    event.target.className = 'active';
    this.hiddenRadio.checked = true;
  };

  handleRangeInputBlur = event => {
    event.target.className = '';
    if (parseInt(this.state.duration.min) > parseInt(this.state.duration.max)) {
      this.setState({
        duration: {
          min: this.state.duration.max,
          max: this.state.duration.min
        }
      });
    }
  };

  handleRangeInputChange = event => {
    this.setState(
      {
        duration: {
          ...this.state.duration,
          name: '',
          [event.target.name]: Math.abs(parseInt(event.target.value))
            ? Math.abs(parseInt(event.target.value))
            : ''
        }
      },
      () =>
        this.props.on_change_duration &&
        this.props.on_change_duration(this.state.duration)
    );
  };

  formatName = duration => {
    return duration.name
      ? duration.name
      : `${duration.min}-${duration.max} dni`;
  };

  returnSearchedValue = () => this.state.duration;
}



// WEBPACK FOOTER //
// ./app/javascript/common/components/trip-length.js